module.exports = __webpack_public_path__ + "fonts/montserrat-semibolditalic-webfont.5c0da78.woff";